import * as yup from 'yup';
import { LODGEMENTS } from './enum';

const validationSchema = yup.object({
  lodgement: yup.string().oneOf(LODGEMENTS).required(),
});

export default validationSchema;
